import { Title, Body } from '@panwds/react-ui'

export interface IScreenHeaderProps {
  title: string;
  subTitle?: string;
}
const ScreenHeader = (props: IScreenHeaderProps) => {
  const { title, subTitle } = props
  return (
    <div className='tw-justify-ceneter tw-pb-5 tw-pt-5'>
      <Title addClassName='tw-flex' level={1} size={'sm'}>
        {title}
      </Title>
      <Body appearance={'secondary'}>{`${subTitle}`}</Body>
    </div>
  )
}

export default ScreenHeader
